import { render } from "./MedicinesCategoriesDropdown.vue?vue&type=template&id=56b9796c"
import script from "./MedicinesCategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./MedicinesCategoriesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__